import axios from "./axiosInstance";

const SpecialTripsAPI = {
  getSpecialTrips: () => axios.get(`/specialtrips`),
};

export default SpecialTripsAPI;